export default __webpack_public_path__ + "static/media/scale-text.8734c823.jpg";